<template>
    <form v-on:submit="save">
        <div class="card card-info">
            <div class="card-header with-border">
                <h3 class="card-title">Teacher Course Allotment</h3>
            </div>
            <!-- /.box-header -->
            <!-- form start -->

            <div class="card-body">
                <div class="row" v-show="editID == 0">

                    <div class="col-lg-4 col-md-6 col-sm-12 ">
                        <div class="form-group">
                            <label>Department</label>
                            <v-select v-model="data.Department" v-bind:multiple="false" v-bind:options="departments" label="Name" style="max-width: 100%;" v-on:input="loadEmployees()"></v-select>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-12 ">
                        <div class="form-group">
                            <label>Employee</label>
                            <v-select v-model="data.Employee" v-bind:multiple="false" v-bind:options="employees" label="Name" style="max-width: 100%;" v-on:input="loadAssignedCourses()"></v-select>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="form-group">
                            <label>Program</label>
                            <select class="form-control" v-model="data.ProgramID" v-on:change="loadBatch()" required="required">
                                <option value="0" disabled="disabled">--Select Program--</option>
                                <option v-for="item in programs" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
                            </select>
                        </div>
                    </div>

                    <div class=" col-lg-4 col-md-6 col-sm-12">
                        <div class="form-group">
                            <label>Session</label>
                            <select class="form-control" v-model="data.SessionID" v-on:change="loadCourses()" required="required">
                                <option value="0" disabled="disabled">--Select Session--</option>
                                <option v-for="item in sessions" v-bind:value="item.SessionID">{{item.Name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="form-group">
                            <label>Courses</label>
                            <v-select v-model="data.Course" v-bind:multiple="false" v-bind:options="courses" label="Data" v-on:input="courseChange()"></v-select>
                        </div>
                    </div>


                    <div class="col-lg-4 col-md-6 col-sm-12 ">
                        <div class="form-group">
                            <label>Type</label>
                            <select class="form-control" v-model="data.Type" v-on:change="courseTypeChange()" required="required">
                                <option disabled="disabled" selected="selected" value="0">--Select Type--</option>
                                <option v-if="data.ShowTheory" value="Theory">Theory</option>
                                <option v-if="data.ShowLab" value="Lab">Lab</option>
                            </select>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-12" v-if="data.Type != '0'">
                        <div class="form-group">
                            <label>{{data.Type}} Total Marks</label>
                            <input type="text" class="form-control" placeholder="Theory total marks" v-model.number="data.TheoryMarks" v-if="data.Type == 'Theory'" />
                            <input type="text" class="form-control" placeholder="Lab total marks" v-model.number="data.LabMarks" v-if="data.Type == 'Lab'" />
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-6 col-sm-12" v-if="editID != 0">
                        <div class="form-group">
                            <label>Total Marks</label>
                            <input type="text" class="form-control" placeholder="Total marks" v-model.number="data.TotalMarks" />
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 ">
                        <div class="form-group">
                            <label>Class Name (Optional)</label>
                            <input type="text" class="form-control" v-model="data.SectionName" maxlength="25" />
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="checkbox">
                            <label style="margin-top: 30px">
                                <input type="checkbox" v-model="data.Countable" />Countable (Check it, if within instructor workload)
                            </label>
                        </div>
                    </div>
                </div>
                <!--<%--<div class="row">
                  <div class="col-md-12">
                    <h4>Secondary Teacher</h4>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th width="5%">Sr. No.</th>
                          <th width="45%">Employee</th>
                          <th width="45%">Credit Hour</th>
                          <th width="5%"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, ind) in SecondaryTeacher">
                          <td>{{ind+1}}</td>
                          <td>
                            <v-select v-model="item.Emp" v-bind:multiple="false" v-bind:options="employees" label="Data" style="max-width: 100%;" v-on:input="teacherChange(ind)"></v-select>
                          </td>
                          <td>
                            <input class="form-control" v-model="item.CreditHours" />
                          </td>
                          <td>
                            <button v-on:click="removeTeacher(ind)" type="button" class="btn" style="border: none; background-color: transparent; color: red"><i class="fa fa-trash fa-2x"></i></button>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="4">
                            <button class="btn" type="button" style="width: 100%" v-on:click="AddNewTeacher()">+ Add new</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>--%>-->

                <div class="row">
                    <div class=" col-lg-12" v-show="students.length > 0">
                        <div class="form-group">
                            <label>Sections</label>
                            <div v-for="(item, ind) in sections" class="checkbox">
                                <label>
                                    <input style="margin-top: 0px;" type="checkbox" v-model="item.Selected" v-on:change="sectionChange(ind)">
                                    {{item.Batch}}
                                </label>
                            </div>
                            <div>
                                Selected Students <b>{{students.filter((x) => {return x.Selected;}).length}}</b>
                            </div>
                            <br />
                            <label>Students enrolled in selected course</label>
                            <table class="table table-color table-sm table-bordered" id="tblStudent">
                                <thead class="bg-info">
                                    <tr>
                                        <th>Roll No.</th>
                                        <th>
                                            <div class="checkbox">
                                                <label>
                                                    <input style="margin-top: 0px;" type="checkbox" v-model="stcheck" v-on:change="masterCheckStudents()">
                                                    Student Name
                                                </label>
                                            </div>
                                        </th>
                                        <th>Father Name</th>
                                        <th>Program</th>
                                        <th>Batch</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in students">
                                        <td>{{item.RollNo}}</td>
                                        <td>
                                            <div class="checkbox">
                                                <label>
                                                    <input v-if="item.IsAllowed" style="margin-top: 0px;" type="checkbox" v-model="item.Selected">
                                                    {{item.Name}}
                                                </label>
                                            </div>
                                        </td>
                                        <td>{{item.FathersName}}</td>
                                        <td>{{item.Program}}</td>
                                        <td>{{item.Batch}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- /.tab-content -->
            </div>
            <hr />
            <!--Button -->
            <div class="card-footer">
                <div class="col-md-12 text-right">
                    <button class="btn btn-success  " type="submit" v-if="editID == 0">Save</button>
                    <button class="btn btn-success  " type="button" v-else v-on:click="update()">Save</button>
                    <!--<button class="btn btn-primary" type="button" v-on:click="cancel()">Back to List</button>-->
                    <button class="btn btn-primary" type="button">Clear</button>
                </div>
            </div>

        </div>
        <div class="card card-info" v-if="data.Employee != null">
            <div class="card-header with-border">
                <h3 class="card-title">Assigned Courses</h3>
            </div>
            <!-- /.box-header -->
            <!-- form start -->

            <div class="card-body">
                <div class="row">
                    <div class=" col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="table-responsive">
                            <table class="table table-sm table-bordered table-color">
                                <thead class="bg-info">
                                    <tr>
                                        <th>Program</th>
                                        <th>Batch</th>
                                        <th>Course Code</th>
                                        <th>Course Name</th>
                                        <th>Type</th>
                                        <th>Total Marks</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in alreadyAssigned">
                                        <td>{{item.Program}}</td>
                                        <td>{{item.Section}}</td>
                                        <td>{{item.CourseCode}}</td>
                                        <td>{{item.CourseName}}</td>
                                        <td>{{item.Type}}</td>
                                        <td>{{item.TotalMarks}}</td>
                                        <td>
                                            <button v-if="item.InsertedBy === userID" type="button" class="btn btn-danger" v-on:click="deleteConfirm(item.TeacherCourseAllotmentID)">Delete</button>
                                            <button v-if="item.InsertedBy === userID" type="button" class="btn btn-info" v-on:click="edit(item.TeacherCourseAllotmentID)">Manage Students</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
                <!-- /.tab-content -->
            </div>
        </div>

        <!-- Modal -->
        <div id="mdlDelete" class="modal fade" role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Confirmation</h4>
                    </div>
                    <div class="modal-body text-center">
                        <h3>Are you sure!</h3>
                        <h4 class="text-danger">Do you want to delete this record?</h4>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" v-on:click="deleteTeacher()">Delete</button>
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    </div>
                </div>

            </div>
        </div>
    </form>
</template>

<script>const axios = require('axios').default;
    export default ({
        data() {
            return {
                departments: [],
                employees: [],
                programs: [],
                sessions: [],
                students: [],
                courses: [],
                alreadyAssigned: [],
                sections: [],
                stcheck: false,
                editID: 0,
                userID: 0,
                SecondaryTeacher: [],
                data: { Department: null, Employee: null, ProgramID: 0, SessionID: 0, Countable: false, Course: null, ShowTheory: false, Theory: false, ShowLab: false, Lab: false, TheoryMarks: '', LabMarks: '', Type: '0', SectionName: '', EmployeeAppointmentD: 0 },
                deleteID: 0,

            }
        },
        created: function () {
            this.loadDepartments();
            this.loadPrograms();
        },

        updated: function () {
            //$('#tblStudent').DataTable();
        },

        methods:
        {
            loadDepartments() {
                var vm = this;
                startReq();
                axios.post('/api/DCApi/loadDepartments')
                    .then(function (response) {
                        vm.departments = response.data.record;
                        endReq();
                    })
            },

            loadEmployees() {
                var vm = this;
                if (vm.data.Department != null) {
                    startReq();
                    axios.post('/api/DCApi/loadEmployees?depID=' + vm.data.Department.DepartmentID)
                        .then(function (response) {
                            vm.employees = response.data.record;
                            vm.students = [];
                            vm.data.Course = null;
                            endReq();
                        })
                }
            },

            loadPrograms() {
                var vm = this;
                axios.post('/api/DCApi/loadAllPrograms')
                    .then(function (response) {
                        if (response.data.status) {
                            vm.programs = response.data.prog;
                        }
                    })
            },

            loadBatch() {
                var vm = this;
                startReq();
                axios.post('/api/DCApi/loadSessions?progID=' + vm.data.ProgramID)
                    .then(function (response) {
                        if (response.data.status) {
                            vm.sessions = response.data.record;
                            vm.students = [];
                            endReq();
                        }

                    })
            },

            loadAssignedCourses() {
                var vm = this;
                if (vm.data.Employee != null) {
                    startReq();
                    axios.post('/api/DCApi/loadTeacherCourse?empID=' + vm.data.Employee.EmployeeID)
                        .then(function (res) {
                            vm.alreadyAssigned = res.data.record;
                            vm.userID = res.data.UserID;
                            vm.students = [];
                            vm.data.Type = 0;
                            endReq();
                        });
                }
            },

            loadCourses() {
                var vm = this;
                startReq();
                axios.post('/api/DCApi/loadCourses2?progID=' + vm.data.ProgramID + '&sesID=' + vm.data.SessionID)
                    .then(function (response) {
                        if (response.data.status) {
                            vm.courses = response.data.record;
                            vm.students = [];
                            endReq();
                        }
                        else {
                            toastr.error(response.data.msg);
                        }
                    })
            },

            AddNewTeacher() {
                this.SecondaryTeacher.push({
                    Emp: null,
                    CreditHours: '',
                    EmployeeAppointmentD: 0,
                    EmployeeID
                })
            },

            removeTeacher(ind) {
                this.SecondaryTeacher.splice(ind, 1);
            },

            teacherChange(ind) {
                this.SecondaryTeacher[ind].EmployeeAppointmentD = this.SecondaryTeacher[ind].Emp.EmployeeAppointmentD;
                this.SecondaryTeacher[ind].EmployeeID = this.SecondaryTeacher[ind].Emp.EmployeeID;
            },

            courseChange() {
                var vm = this;
                if (vm.data.Course != null) {
                    startReq();
                    axios.post('/api/DCApi/courseChange?id=' + vm.data.Course.RoadMapChildID)
                        .then(function (res) {
                            endReq();
                            if (res.data.status) {
                                vm.data.Theory = false;
                                vm.data.Lab = false;
                                vm.data.ShowLab = res.data.allowLab;
                                vm.data.ShowTheory = res.data.allowTheory;
                                vm.data.Type = '0';
                                var table = $('#tblStudent').DataTable();
                                table.destroy();
                                vm.students = [];
                            }
                            else {
                                toastr.error("Course is already assigned");
                                vm.data.Course = null;
                            }
                        })
                }
            },

            courseTypeChange() {

                var vm = this;

                startReq();
                axios.post('/api/DCApi/courseTypeChange?crsID=' + vm.data.Course.RoadMapChildID + '&empID=' + vm.data.Employee.EmployeeID + '&type=' + vm.data.Type)
                    .then(function (res) {

                        endReq();
                        if (res.data.status) {

                            vm.stcheck = false;
                            //var table = $('#tblStudent').DataTable();
                            //table.destroy();
                            vm.students = res.data.students;
                            vm.sections = res.data.sel;
                            //$('#tblStudent').DataTable();
                        }
                    });
            },

            sectionChange(ind) {
                var vm = this;
                var ses = vm.sections[ind];
                console.log(ses);
                vm.students.filter((x) => { return x.IsAllowed; }).forEach(function (item) {
                    if (ses.Selected && item.SectionID == ses.SectionID)
                        item.Selected = true;
                    else if (!ses.Selected && item.SectionID == ses.SectionID)
                        item.Selected = false;
                });
            },

            masterCheckStudents() {
                var vm = this;
                startReq();
                vm.students.forEach(function (item) {
                    if (item.IsAllowed)
                        item.Selected = vm.stcheck;
                });
                endReq();
            },


            save(e) {
                e.preventDefault();
                var vm = this;

                if (vm.data.Employee == null) {
                    toastr.error("Employee is required");
                    return;
                }

                if (vm.data.Course == null) {
                    toastr.error("Course is required");
                    return;
                }

                //if (!vm.data.Theory && !vm.data.Lab) {
                //    toastr.error("Please select Theory / Lab");
                //    return;
                //}

                if (vm.data.Type == '0' || vm.data.Type == 0) {
                    toastr.error("Please select type");
                    return;
                }

                if (vm.data.Type == "Theory" && (vm.data.TheoryMarks == '' || vm.TheoryMarks == 0)) {
                    toastr.error("Theory Total Marks is required");
                    return;
                }

                if (vm.data.Type == "Lab" && (vm.data.LabMarks == '' || vm.LabMarks == 0)) {
                    toastr.error("Lab Total Marks is required");
                    return;
                }

                if (this.data.TheoryMarks == '')
                    this.data.TheoryMarks = 0;

                if (this.data.LabMarks == '')
                    this.data.LabMarks = 0;

                startReq();

                axios.post('/api/DCApi/save?compID=' + vm.data.Employee.EmployeeAppointmentID + '&courseID=' + vm.data.Course.RoadMapChildID + '&secID=' + vm.sections[0].SectionID + '&theory=' + vm.data.Theory + '&lab=' + vm.data.Lab + '&thMarks=' + vm.data.TheoryMarks + '&lbMarks=' + vm.data.LabMarks + '&progID=' + vm.data.ProgramID + '&type=' + vm.data.Type + '&sectionName=' + vm.data.SectionName + '&countable=' + vm.data.Countable, {
                    students: vm.students.filter((x) => { return x.Selected; }),
                    secTeach: vm.SecondaryTeacher
                })
                    .then(function (response) {
                        endReq();
                        if (response.data.status) {
                            toastr.success("Saved Successfully", "Done!");
                            vm.alreadyAssigned = response.data.record;
                            //setTimeout(function () { window.location.reload() }, 2000);
                            vm.clear();
                        }
                        else {
                            toastr.error("Internal error occurred");
                        }
                    })
            },

            clear() {
                this.data.Course = null;
                this.data.Employee = null;
                this.data.Department = null;
                this.data.ShowLab = false;
                this.data.ShowTheory = false;
                this.data.Lab = false;
                this.data.Theory = false;
                this.data.TheoryMarks = 0;
                this.data.LabMarks = 0;
                this.data.Type = '0';
                this.data.SectionName = '';
                this.data.Countable = '';
                //this.students = [];
                this.editID = 0;
                //employees
            },

            cancel() {
                window.location.reload();
                //window.location.href = "/DC/AllTeacherCourseAllotment";
            },

            edit(id) {
                var vm = this;
                startReq();
                axios.post('/api/DCApi/edit?id=' + id)
                    .then(function (res) {
                        if (res.data.status) {
                            vm.stcheck = false;
                            //var table = $('#tblStudent').DataTable();
                            //table.destroy();
                            vm.sections = res.data.sel;
                            vm.SecondaryTeacher = res.data.secteacher;
                            var dd = res.data.parent;
                            vm.data.SectionName = dd.SectionName;
                            vm.data.TotalMarks = dd.TotalMarks;
                            vm.data.Countable = dd.Countable;
                            vm.students = res.data.students;
                            //$('#tblStudent').DataTable();
                            vm.editID = id;
                            endReq();
                        }
                        else {
                            endReq();
                            toastr.error(res.data.msg);
                        }
                    });
            },

            update() {
                var vm = this;
                startReq();
                axios.post('/api/DCApi/update?id=' + vm.editID + '&sectionName=' + vm.data.SectionName + '&totalmarks=' + vm.data.TotalMarks + '&countable=' + vm.data.Countable, {
                    students: vm.students.filter((x) => { return x.Selected; }),
                    secTeach: vm.SecondaryTeacher,
                })
                    .then(function (res) {
                        if (res.data.status) {
                            toastr.success("Saved Successfully", "Done!");
                          vm.loadAssignedCourses();
                          vm.clear();
                            //setTimeout(function () { window.location.reload() }, 2000);
                            endReq();
                        }
                        else {
                            endReq();
                            toastr.error(res.data.msg);
                        }
                    });
            },

            deleteConfirm(id) {
                this.deleteID = id;
                $('#mdlDelete').modal('show');
            },

            deleteTeacher() {
                var vm = this;
                startReq();
                axios.post('/api/DCApi/delete?id=' + vm.deleteID)
                    .then(function (res) {
                        if (res.data.status) {
                            vm.deleteID = '';
                            $('#mdlDelete').modal('hide');
                            toastr.success("Deleted Successfully");
                            vm.loadAssignedCourses();
                        }
                        else {
                            endReq();
                            toastr.error(res.data.msg);
                        }
                    });
            }

        }
    })</script>



// WEBPACK FOOTER //
// src/components/DC/newTeacherCourseAlloment.vue